module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_niconico_m2.ae75c99d0b71be0a9cbf78e06220b784.png";